var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.filterTitle))]),_vm._v(" "),_c('div',{staticClass:"filter"},[_c('vue-datepicker-local',{class:_vm.sizeClass,attrs:{"disabledDate":_vm.disabledDate,"value":_vm.selectedDate,"local":_vm.local,"format":_vm.formatDate},on:{"input":_vm.emitDateSelected}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c5b75ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/controlsbar/ControlsFilter.vue
// module id = null
// module chunks = 